@if (menu$ | async) {
  @if (items()?.length) {
    <div
      class="toolbar-menu-container"
      [class.toolbar-menu-container--overflow]="hasOverflow()"
    >
      <button
        type="button"
        class="toolbar-menu-nav-btn toolbar-menu-nav-btn--left"
        [class.toolbar-menu-nav-btn--visible]="showLeftArrow()"
        aria-label="Scroll toolbar menu left"
        (click)="scrollLeft()"
      >
        <span class="toolbar-menu-nav-btn__icon icon-wo-arrow"></span>
      </button>

      <div
        #scrollContainer
        class="toolbar-menu-scroll"
        [class.toolbar-menu-scroll--overflow]="hasOverflow()"
        (scroll)="syncScrollState()"
      >
        @for (item of items(); track item.id) {
          <app-toolbar-menu-item
            [item]="item"
            [last]="$last"
          ></app-toolbar-menu-item>
        }
      </div>

      <button
        type="button"
        class="toolbar-menu-nav-btn toolbar-menu-nav-btn--right"
        [class.toolbar-menu-nav-btn--visible]="showRightArrow()"
        aria-label="Scroll toolbar menu right"
        (click)="scrollRight()"
      >
        <span class="toolbar-menu-nav-btn__icon icon-wo-arrow"></span>
      </button>
    </div>
  }
}
